// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"4265b9be","455":"86c866f3","488":"4c566ca6"}[chunkId] + ".chunk.js";
};